import mixpanel from "mixpanel-browser";

const useAnalyticsMixpanelHook = () => {
    function trackViewDetailedAnalytics({
        cta = "View Detailed Analytics",
        ctaType = "Click",
        source = "Bundles Tab",
    }) {
        const payload = {
            Cta: cta,
            "Cta Type": ctaType,
            Source: source,
            Page: "Analytics",
        };

        console._log("kefiAnalytics: View Detailed Analytics", payload);
        mixpanel.track("View Detailed Analytics", payload);
    }

    function trackContactSupport({ cta = "Contact Support", ctaType = "Click" }) {
        const payload = {
            Cta: cta,
            "Cta Type": ctaType,
            Page: "Analytics",
        };

        console._log("kefiAnalytics: Contact Support", payload);
        mixpanel.track("Contact Support Clicked", payload);
    }

    function trackAnalyticsTabSwitch({ tabName = "" }) {
        const payload = {
            "Tab Name": tabName || "-",
            Page: "Analytics",
        };

        console._log("kefiAnalytics: Analytics Tab Switched", payload);
        mixpanel.track("Analytics Tab Switched", payload);
    }

    function trackAnalyticsFilters({ filterType = "", value = "" }) {
        const payload = {
            "Tab Name": filterType || "-",
            Value: value || "-",
            Page: "Analytics",
        };

        console._log("kefiAnalytics: Analytics Filters Applied", payload);
        mixpanel.track("Analytics Filters Applied", payload);
    }

    function trackStartAnalyticsSession(pageName: string) {
        mixpanel.time_event("Analytics Page Session Time");
        console._log("kefiAnalytics: Start Analytics Session Timer", { pageName });
    }

    function trackStopAnalyticsSession(pageName: string, extraProps: Record<string, any> = {}) {
        const payload = {
            Page: pageName || "Analytics Page",
            ...extraProps,
        };

        console._log("kefiAnalytics: Stop Analytics Session Timer", payload);
        mixpanel.track("Analytics Page Session Time", payload);
    }

    return {
        trackViewDetailedAnalytics,
        trackAnalyticsTabSwitch,
        trackAnalyticsFilters,
        trackContactSupport,
        trackStartAnalyticsSession,
        trackStopAnalyticsSession,
    };
};

export default useAnalyticsMixpanelHook;
